import React from 'react';
import Link from '../components/Link';
import Line from '../components/Line';
import Image from '../components/Image';
import CommissionText from '../components/CommissionText';
import {
    paddypower as paddypowerUrls,
    common as commonUrls,
} from '../urlConstants';
import '../styles.scss';

const PaddyPower = () => (
    <div className="bs-gamblingCompliance">
        <div className="bs-gamblingCompliance__images">
            <Image href={paddypowerUrls.gamCommission} imageName="gamCommission" />
            <Image href={paddypowerUrls.mga} imageName="mga" />
        </div>
        <div className="bs-gamblingCompliance__message">
            <Line className="bs-gamblingCompliance__line">
                <Link
                    href={paddypowerUrls.terms}
                    text="Terms and Conditions."
                />
            </Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                <Link
                    href={paddypowerUrls.responsibleGambling}
                    text="Gambling can be addictive, please play responsibly."
                />
            </Line>
        </div>
        <div className="bs-gamblingCompliance__message">
            <Line>
                PPB Counterparty Services Limited, having its registered address at
                Triq il-Kappillan Mifsud, St. Venera, SVR 1851, MALTA, is&nbsp;
                <Link href={paddypowerUrls.license} text="licensed" />&nbsp;
                and regulated by the&nbsp;
                <Link href={paddypowerUrls.gamingAuthority} text="Malta Gaming Authority" />&nbsp;
                under Licence Number MGA/CRP/131/2006 (issued on 01 August 2018).
                For customers in the UK,&nbsp;
                <Link
                    href={paddypowerUrls.gamingCommission}
                    text="PPB Counterparty Services Limited"
                /> is&nbsp;
                <Link href={paddypowerUrls.license} text="licensed" />&nbsp;
                and regulated by the Gambling Commission.
            </Line>
            &nbsp;
            <CommissionText />
        </div>
        <div className="bs-gamblingCompliance__images">
            <Image href={paddypowerUrls.underage} imageName="underageRed" />
            <Image href={commonUrls.gamtherapy} imageName="gamtherapyTransparent" />
            <Image href={commonUrls.gamcare} imageName="gamcare" />
            <Image href={commonUrls.funstops} imageName="funstops" />
            <Image href={commonUrls.gamstop} imageName="gamstop" />
            <Image href={commonUrls.raig} imageName="raig" />
        </div>
    </div>
);

export default PaddyPower;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/PaddyPower/fullGamblingCompliance.jsx